<template>
    <div class="main-banner-area">
        <div class="container">
            <div class="row">
                <div class="col-lg-8 col-md-12">
                    <div class="main-banner-content">
                        <div class="content">
                            <span class="sub-title text-uppercase  ">#Business Solutions For You</span>
                            <h1>Streamline, Scale, Succeed: Software Solutions for Modern Business </h1>
                            <div class="banner-flex-solutions">                      
                              <button @click="openCalendly" class="default-btn">Get a Free Consultation</button>
                            <button class="default-btn ms-2" @click="$router.push('/projects')">Explore Solutions</button>
                            </div>

                            
                            <aside class="widget-area left-sidebar max-w-70" style=" margin-top: 25px;" >
                                <div class="widget widget_search landing-page-search">
                                    <form :class="`search-form ${ isContect ? 'd-none': 'd-block'} d-md-block`" @submit.prevent>
                                <label class="search-container">
                                  <input 
                                    type="text" 
                                    class="search-field main-search-field" 
                                    placeholder="Looking for a service? Start typing here..." 
                                    v-model="searchQuery"
                                    @input="handleSearch"
                                    @focus="showSearchResults = true"
                                    @blur="handleBlur"
                                  >
                                  <button type="button" :class="{'hide-search-btn': showSearchResults && filteredApps.length > 0}">
                                    <svg fill="#FFFFFF" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 16" width="16px" height="16px"><path d="M13.438,15.563l-2.665-2.664	C9.684,13.598,8.388,14.002,7,14.002c-3.865,0-7-3.135-7-7c0-3.864,3.135-7,7-7c3.864,0,7,3.136,7,7	c0,1.391-0.407,2.687-1.105,3.776l2.665,2.664c0.585,0.585,0.585,1.536,0,2.121C14.974,16.148,14.024,16.148,13.438,15.563z M12,7.002c0-2.759-2.241-5-5-5c-2.76,0-5,2.241-5,5c0,2.76,2.24,5,5,5C9.759,12.002,12,9.762,12,7.002z"/></svg>
                                  </button>
                                  <!-- Search Results Dropdown -->
                                  <div v-if="showSearchResults &&  filteredApps.length > 0" class="search-results-dropdown">
                                    <div 
                                      v-for="app in filteredApps" 
                                      :key="app.slug"
                                      class="search-result-item"
                                      @click="navigateToApp(app.slug)"
                                    >
                                      {{ app.name }}
                                    </div>
                                  </div>
                                </label>
                              </form>
                                </div>
                            </aside>
                            
                        </div>
                        <TrustedBy />
                    </div>
                </div>
                <div class="col-lg-4 col-md-12 mob-banner-img">
                    <div class="main-banner-image" data-aos="fade-up">
                        <img src="../../assets/images/banner/banner-app-new.png" alt="image" class="banner-image-home">
                    </div>
                </div>
            </div>
        </div>
        <div class="shape-overlay"></div>
        <div class="banner-shape1"><img src="../../assets/images/shape/shape9.png" alt="image"></div>
        <div class="banner-shape2"><img src="../../assets/images/shape/shape7.png" alt="image"></div>
        <div class="banner-shape3"><img src="../../assets/images/shape/shape2.png" alt="image"></div>
        <div class="banner-shape4"><img src="../../assets/images/shape/shape10.png" alt="image"></div>
        <div class="banner-shape5"><img src="../../assets/images/shape/shape11.png" alt="image"></div>
    </div>
</template>

<script>
import TrustedBy from '../HomeOne/TrustedBy'
import { watchEffect } from "vue";
import { Search_APP, useGetNavMenuData } from '../../services/graphqlService';
import apolloClient from '../../apollo';

export default {
    name: 'MainBanner',
    props: {
      openPopup: Function, // Use the Function type directly
    },
    components: {
        TrustedBy
    },
    data() {
      return {
        searchQuery: '',
        showSearchResults: false,
        filteredApps: [],
        allApps: [],
        appCategories: [],
      }
    },
    mounted: async function () {
      await this.getNavMenuData();
    },
    methods: {
      openCalendly() {
        // eslint-disable-next-line no-undef
        Calendly.initPopupWidget({url:'https://calendly.com/connect-to-meander/30min'});
        return false;
      },
      async getNavMenuData() {
        const { result, onError } = useGetNavMenuData();
        watchEffect(() => {
          if (result?.value?.businessModelCategories?.length) {
            this.appCategories = result?.value?.businessModelCategories;
            this.extractAllApps();
          }
        });
        onError((error) => {
          console.error("Error fetching app by slug:", error);
        });
      },

      async handleSearch() {
        if (this.searchQuery.trim() === '') {
          this.filteredApps = [];
          return;
        }
        const query = this.searchQuery.toLowerCase();
  const variables ={
  "filters": {
    "or": [
      {
        "clone_synonyms": {
          "containsi": query
        }
      },
      {
        "alias_synonyms": {
          "containsi": query
        }
      },
      {
        "keywords": {
          "containsi": query
        }
      },
      {
        "name": {
          "containsi": query
        }
      },
      {
        "description": {
          "containsi": query
        }
      },
    ]
    
  },
  pagination: { page: 1, pageSize: 100 }
}
  const { data } = await apolloClient.query({
        query: Search_APP,
        variables
      })
      watchEffect(() => {
    
       this.filteredApps =data?.apps
       
      });
        
    
      },

      // handleSearch() {
      //   if (this.searchQuery.trim() === '') {
      //     this.filteredApps = [];
      //     return;
      //   }
      //   const query = this.searchQuery.toLowerCase();
      //   this.filteredApps = this.allApps.filter(app => 
      //     app.name.toLowerCase().includes(query)
      //   ).slice(0, 10); // Limit to 10 results
      // },
      handleBlur() {
        setTimeout(() => {
          this.showSearchResults = false;
        }, 200);
      },
      navigateToApp(slug) {
        this.showSearchResults = false;
        this.searchQuery = '';
        this.$router.push(`/app-detail/${slug}`);
      },
      extractAllApps() {
        this.allApps = [];
        if (this.appCategories && this.appCategories.length > 0) {
          this.appCategories.forEach(category => {
            if (category.business_models && category.business_models.length > 0) {
              category.business_models.forEach(app => {
                this.allApps.push({
                  name: app.name,
                  slug: app.slug
                });
              });
            }
          });
        }
      },
    }
}
</script>

<style scoped>
.search-container {
  position: relative;
  display: block;
  width: 100%;
}

.search-results-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 11111 !important;
  margin-top: 2px;
}

.search-result-item {
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.2s ease;
}

.search-result-item:hover {
  background-color: #f8f9fa;
}

.search-result-item:last-child {
  border-bottom: none;
}

@media (max-width: 768px) {
  .search-results-dropdown {
    max-height: 300px;
  }
}

/* Hide the search button when dropdown is open */
.hide-search-btn {
  display: none !important;
}
.landing-page-search {
    width: 88%;
}
</style>